import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { TokenService } from 'src/app/auth/services/token/token.service';
import { LoginService } from '@auth/services/login/login.service';

export const AuthGuard: CanActivateFn = async (route, state) => {
  const _token = inject(TokenService);
  const _service = inject(LoginService);

  const login = await _token.isValidLogin();
  _service.isValidLogin.set(login);
  if (!login) {
    _service.logout();
    return false;
  }
  return true;
};
